<template>
    <teleport to="body">
      <transition name="modal-fade">
        <div v-if="modelValue" class="modal-overlay" @click.self="close">
          <div class="modal-box">
            <div class="modal-header">
              <i :class="['fa', icon]" class="modal-icon"></i>
              <h3>{{ title }}</h3>
            </div>
            <div class="modal-content">
              <!-- <slot v-html="content"></slot> -->

              <div class="modal-content" v-html="content"></div>
            </div>
            <!-- <div class="modal-footer">
              <button @click="onPrimary" class="modal-btn primary">{{ primaryBtn }}</button>
              <button @click="onSecondary" class="modal-btn secondary">{{ secondaryBtn }}</button>
            </div> -->
          </div>
        </div>
      </transition>
    </teleport>
  </template>
  
  <script>
  export default {
    name: 'BaseModal',
    props: {
      modelValue: { type: Boolean, default: false },
      title: { type: String, required: true },
      content: { type: String, default: '' },
      primaryBtn: { type: String, default: 'OK' },
      secondaryBtn: { type: String, default: 'Cancel' },
      icon: { type: String, default: 'fa-info-circle' }
    },
    methods: {
        close() {
            this.$emit('update:modelValue', false);
        },
        onPrimary() {
            this.$emit('primary');
            this.close();
        },
        onSecondary() {
            this.$emit('secondary');
            this.close();
        }
    }
  }
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
  .modal-box {
    background: #fff;
    padding: 24px;
    border-radius: 8px;
    min-width: 320px;
    max-width: 70vw;
    max-height: 70vh;
    box-shadow: 0 8px 32px rgba(0,0,0,0.15);
    overflow: auto;
  }
  .modal-header {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .modal-icon {
    font-size: 24px;
    color: #3467eb;
  }
  .modal-content {
    margin: 16px 0;
  }
  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
  .modal-btn {
    padding: 6px 18px;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
  }
  .modal-btn.primary { background: #3467eb; color: #fff; }
  .modal-btn.secondary { background: #eee; color: #333; }

  h3{
    border-bottom:3px solid var(--color-system-primary);
    padding:0 10px;
  }

  </style>
  